import { render, staticRenderFns } from "./PowerAppV5.vue?vue&type=template&id=292b809c"
import script from "./PowerAppV5.vue?vue&type=script&lang=js"
export * from "./PowerAppV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports